module.exports = __webpack_public_path__ + "static/img/title-banner1-type2.9991900.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/8/title-banner1-type2.png
// module id = JH+R
// module chunks = 1